import React from 'react';
import styled from 'styled-components';
import { TopBarNavigation } from '../MainSection/components/TopBarNavigation';
import ContactUsMain from '../../img/ContactUs/ContactUsMain.png';
import { SubPageBannerImage, SubPageHeader } from '../../view/Banner/Banner';
import { ContactSectionBody } from './components/ContactSectionBody';

const ContactSectionBanner = styled.section`
  position: relative;
  padding-bottom: 20px;
  padding-top: 9px;
  background-attachment: fixed;
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  flex-direction: column;
`;

export const ContactSection = (): JSX.Element => (
  <ContactSectionBanner>
    <TopBarNavigation />
    <SubPageBannerImage image={ContactUsMain} />
    <SubPageHeader as="h1">
      Kontakt
    </SubPageHeader>
    <ContactSectionBody />
  </ContactSectionBanner>
);
